<template>
	<div class="header-page">
    <div class="header-content disflex" @touchmove.prevent>
      <div class="menu">
        <img style="visibility:hidden" src="static/images/home.png" >
      </div>
      <a class="logo" href="/#/index"><img src="static/images/logo1.png" /></a>
      <div class="account-top" @click="getAcount()" @click.stop>
        <img src="static/images/account-icon2.png" v-if="isShow">
        <img src="static/images/account-icon.png" v-else>
      </div>
    </div>
    <div class="menu-list">
      <ul>
        <li v-for="(item,index) in menus" @click="showMenu(item)" :class="{'active':isActive==item.url}">
            <span v-html="item.name"></span>
        </li>
      </ul>
    </div>
    <div class="drop-down-content" v-if="isShow" @touchmove.prevent @click.stop>
      <div class="drop-down">
        <div class="drop-down-top">
          <div class="span">{{$t('headerTips1')}}</div>
          <div class="span">{{$t('headerTips2')}}</div>

        </div>
        <div class="drop-down-bottom">
          <div class="one1">
            <router-link :to="{path:'/myAccount'}"><img src="static/images/icon1.png">{{$t('myAccount')}}</router-link>
          </div>
          <div class="one1">
            <a @click="unSubscribe"><img src="static/images/un.png">{{$t('UNSUBSCRIBE')}}</a>
          </div>
          <div class="one1">
            <router-link :to="{path:'/myGames'}"><img src="static/images/icon4.png">{{$t('MyGames')}}</router-link>
          </div>
          <div class="one2">
            <router-link :to="{path:'/faq'}"><img src="static/images/icon2.png">{{$t('FAQs')}}</router-link>
          </div>
          <div class="one3">
            <router-link :to="{path:'/termsAndCondition'}"><img src="static/images/icon3.png">{{$t('TC')}}</router-link>
          </div>
          <div class="one4">
            <router-link :to="{path:'/language'}"><img src="static/images/icon0.png">{{$t('language')}}</router-link>
          </div>
        </div>
      </div>
    <Dialog ref="saveDialog" :callback="saveModal" title="Reminder" :btnText="$t('Yes')" :cancelText="$t('No')">
        <div slot="mdBox" >
            <div class="mt100 fs50">{{$t('des2')}}</div>
        </div>
    </Dialog>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              search:'',
              isShow:false,
              menus:[
                {url:'/index',name:'home'},
                {url:'/mission',name:'mission'},
                {url:'/Mypoints',name:'My<br />points'},
                // {url:'/redeemcenter',name:'redeem<br />center'},
                // {url:'/luckydraw',name:'lucky<br />draw'},
                {url:'/referral',name:'referral'},
              ],
              isActive:'/index',
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,

            }
        },
        mounted() {
          if(this.$route.query.url){
            this.isActive = this.$route.query.url
          }else{
            this.isActive = '/index'
          }
          if(localStorage.getItem('token')){
            this.isLogin = true
          }
          document.addEventListener("click", this.bodyCloseMenus);
         },
         beforeDestroy() {
           document.removeEventListener("click", this.bodyCloseMenus);
          },
		methods: {
      bodyCloseMenus(e) {
         let self = this;
          if (self.isShow == true){
           self.isShow = false;
          }
        },
			showMenu(item){
				let that =this;
				this.isActive = item.url;
        this.$router.push({path:item.url,query:{url:item.url}});
			},
			getAcount(){
				let that =this;
				this.isShow = !this.isShow;
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	//this.isShow = false;
      	this.$refs.saveDialog.showMaskFun();
      },
      // 弹框保存
      saveModal (){
        let that =this;
      	//this.$refs.saveDialog.closeMask();
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/unsubscribe',null,r =>{
        	//that.$parent.returnCode(r,function(){
            that.$utils.alertText(r.msg,80,3000);
            that.$parent.$parent.loadModal(false);
            if(r.code==1){
              localStorage.removeItem('token')
              this.$router.push('/land');
            }else{
              this.$refs.saveDialog.closeMask();
            }
          //});
        })
      }
		}
    }
</script>
<style>
  .drop-down-content{background:#dbebff;position: fixed;
    top: 160px;
    left: 0;
    right:0;
    bottom: 0;
    height: 100%;
    z-index: 10;font-family:ChevinProBold;color:#000;}
  .drop-down{padding:40px;}
  .drop-down-top{border-bottom:3px solid #001f5e;padding-bottom:40px;}
  .span{font-size:27px;}
  .mt20{margin-top:20px;}
  .drop-down-bottom{margin-top:100px;}
  .drop-down-bottom >div{margin:15px 0;}
  .drop-down-bottom a{font-size:32px;}
  .drop-down-bottom img{margin-right:15px;}
  .input{background:#fff;height:47px;border:none;border-radius: 20px;font-size: 27px;font-family:ChevinProBold;padding:0 20px;}
  .input-div{margin:30px 40px 20px;}
  .input-div .span{width:240px;}
  .input-item{background:#fff;border-radius: 20px;height: 50px;line-height: 50px;width: calc(100% - 320px);}
  .input-div div span{font-size:38px;padding-left: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/header.vue